// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 768px)";
var _3 = "service-V-kZm";
var _4 = "header-3F9Md";
var _5 = "service_active-3oi2d";
var _6 = "icon-3lBFR";
var _7 = "header__text-1wLFA";
var _8 = "header__price-15IUp";
var _9 = "content-Dvf4Y";
var _a = "buttons--2Pem";
var _b = "service_transfer-Fbj6v";
var _c = "add-39EIk";
var _d = "priorityBoardingModal-2HseG";
var _e = "header_priority-356Ah";
var _f = "insuranceUpsale_paper-Q5oJn";
var _10 = "insuranceUpsale_content-2e-aL";
var _11 = "insuranceUpsale_options-1ih4K";
export { _1 as "__esModule", _2 as "tabletMiddle", _3 as "service", _4 as "header", _5 as "service_active", _6 as "icon", _7 as "header__text", _8 as "header__price", _9 as "content", _a as "buttons", _b as "service_transfer", _c as "add", _d as "priorityBoardingModal", _e as "header_priority", _f as "insuranceUpsale_paper", _10 as "insuranceUpsale_content", _11 as "insuranceUpsale_options" }
export default { "__esModule": _1, "tabletMiddle": _2, "service": _3, "header": _4, "service_active": _5, "icon": _6, "header__text": _7, "header__price": _8, "content": _9, "buttons": _a, "service_transfer": _b, "add": _c, "priorityBoardingModal": _d, "header_priority": _e, "insuranceUpsale_paper": _f, "insuranceUpsale_content": _10, "insuranceUpsale_options": _11 }
